// extracted by mini-css-extract-plugin
export default {"containerSection":"NavMenu_containerSection__I8dPE","containerContent":"NavMenu_containerContent__x6-a2"};